
import { FormGroup } from '@angular/forms';
import { PaymentMethodTypes } from '../../enums/order-source-type';
import { PaymentProcessor } from './payment-processor.enum';
import { PayvisionSavedCard } from '../../interface/payvision/payvision-saved-card.interface';
import { AddressInformation, ShippingAddressInformation } from '../../interface/address-detail-info';
import { PersonalCheck } from '../../interface/eCheck/payment-echeckrequest.interface';
import { PersonalAch } from '../../interface/ach-payment/payment-achrequest.interface';
import { BaseSettings } from './base-settings.model';

export class PaymentComponentSettings extends BaseSettings {
    paymentMethodTypes = PaymentMethodTypes;
    paymentMethodTypeForm: FormGroup;
    processorTypes = PaymentProcessor;
    isoTwoletterCountryCode: string;
    isAddNewCard = false;
    savedCards: PayvisionSavedCard[];
    cardTypeImage: string;
    memberId: string;
    storeId: number;
    isoCountryCode: string;
    currencyCode: string;
    languageCode: string;
    memberTypeId: number;
    payvisionFormLoaded: boolean;
    webOrderId: string;
    billingAddress: AddressInformation;
    shippingAddressDetail?: ShippingAddressInformation;
    savedEChecks: PersonalCheck[];
    numberDecimals: number;
    memberEmail: string;
    orderReferenceId: string;
    paymentUrl: string;
    orderTypeId?: number;
    savedAchs?: PersonalAch[];
    amount: number;
    orderType?: string;
    distributorId?: string;
    uniqueRefId?: string;
    authorizationCode?: string | any;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/payment.model.ts